export const USER_SETTING_KEY_THEME = "THEME_MODE" as const

export enum ThemeMode {
  Light = "light",
  Dark = "dark",
  System = "system",
}
